import { asEnum } from "./utils";
export var USAStates;
(function (USAStates) {
    USAStates["AL"] = "AL";
    USAStates["AK"] = "AK";
    USAStates["AZ"] = "AZ";
    USAStates["AR"] = "AR";
    USAStates["AS"] = "AS";
    USAStates["CA"] = "CA";
    USAStates["CO"] = "CO";
    USAStates["CT"] = "CT";
    USAStates["DE"] = "DE";
    USAStates["DC"] = "DC";
    USAStates["FL"] = "FL";
    USAStates["GA"] = "GA";
    USAStates["GU"] = "GU";
    USAStates["HI"] = "HI";
    USAStates["ID"] = "ID";
    USAStates["IL"] = "IL";
    USAStates["IN"] = "IN";
    USAStates["IA"] = "IA";
    USAStates["KS"] = "KS";
    USAStates["KY"] = "KY";
    USAStates["LA"] = "LA";
    USAStates["ME"] = "ME";
    USAStates["MD"] = "MD";
    USAStates["MA"] = "MA";
    USAStates["MI"] = "MI";
    USAStates["MN"] = "MN";
    USAStates["MS"] = "MS";
    USAStates["MO"] = "MQ";
    USAStates["MT"] = "MT";
    USAStates["NE"] = "NE";
    USAStates["NV"] = "NV";
    USAStates["NH"] = "NH";
    USAStates["NJ"] = "NJ";
    USAStates["NM"] = "NM";
    USAStates["NY"] = "NY";
    USAStates["NC"] = "NC";
    USAStates["ND"] = "ND";
    USAStates["MP"] = "MP";
    USAStates["OH"] = "OH";
    USAStates["OK"] = "OK";
    USAStates["OR"] = "OR";
    USAStates["PA"] = "PA";
    USAStates["PR"] = "PR";
    USAStates["RI"] = "RI";
    USAStates["SC"] = "SC";
    USAStates["SD"] = "SD";
    USAStates["TN"] = "TN";
    USAStates["TX"] = "TX";
    USAStates["TT"] = "TT";
    USAStates["UT"] = "UT";
    USAStates["VT"] = "VT";
    USAStates["VA"] = "VA";
    USAStates["VI"] = "VI";
    USAStates["WA"] = "WA";
    USAStates["WV"] = "WV";
    USAStates["WI"] = "WI";
    USAStates["WY"] = "WY";
})(USAStates || (USAStates = {}));
export function toISO3166SubdivsionCode(state) {
    return `US-${state}`;
}
export const fullNameForUSAState = {
    [USAStates.AL]: "Alabama",
    [USAStates.AK]: "Alaska",
    [USAStates.AZ]: "Arizona",
    [USAStates.AR]: "Arkansas",
    [USAStates.AS]: "American Samoa",
    [USAStates.CA]: "California",
    [USAStates.CO]: "Colorado",
    [USAStates.CT]: "Connecticut",
    [USAStates.DE]: "Delaware",
    [USAStates.DC]: "District of Columbia",
    [USAStates.FL]: "Florida",
    [USAStates.GA]: "Georgia",
    [USAStates.GU]: "Guam",
    [USAStates.HI]: "Hawaii",
    [USAStates.ID]: "Idaho",
    [USAStates.IL]: "Illinois",
    [USAStates.IN]: "Indiana",
    [USAStates.IA]: "Iowa",
    [USAStates.KS]: "Kansas",
    [USAStates.KY]: "Kentucky",
    [USAStates.LA]: "Louisiana",
    [USAStates.ME]: "Maine",
    [USAStates.MD]: "Maryland",
    [USAStates.MA]: "Massachusetts",
    [USAStates.MI]: "Michigan",
    [USAStates.MN]: "Minnesota",
    [USAStates.MS]: "Mississippi",
    [USAStates.MO]: "Missouri",
    [USAStates.MT]: "Montana",
    [USAStates.NE]: "Nebraska",
    [USAStates.NV]: "Nevada",
    [USAStates.NH]: "New Hampshire",
    [USAStates.NJ]: "New Jersey",
    [USAStates.NM]: "New Mexico",
    [USAStates.NY]: "New York",
    [USAStates.NC]: "North Carolina",
    [USAStates.ND]: "North Dakota",
    [USAStates.MP]: "Northern Mariana Islands",
    [USAStates.OH]: "Ohio",
    [USAStates.OK]: "Oklahoma",
    [USAStates.OR]: "Oregon",
    [USAStates.PA]: "Pennsylvania",
    [USAStates.PR]: "Puerto Rico",
    [USAStates.RI]: "Rhode Island",
    [USAStates.SC]: "South Carolina",
    [USAStates.SD]: "South Dakota",
    [USAStates.TN]: "Tennessee",
    [USAStates.TX]: "Texas",
    [USAStates.TT]: "Trust Territory of the Pacific Islands",
    [USAStates.UT]: "Utah",
    [USAStates.VT]: "Vermont",
    [USAStates.VA]: "Virginia",
    [USAStates.VI]: "Virgin Islands",
    [USAStates.WA]: "Washington",
    [USAStates.WV]: "West Virginia",
    [USAStates.WI]: "Wisconsin",
    [USAStates.WY]: "Wyoming",
};
export function usaStateFromName(name) {
    const enumState = asEnum(USAStates)(name.toUpperCase());
    if (enumState)
        return enumState;
    const normalizedName = name.toLowerCase();
    const stateEntry = Object.entries(fullNameForUSAState).find(([_, stateName]) => stateName.toLowerCase() === normalizedName);
    return stateEntry ? asEnum(USAStates)(stateEntry[0]) : null;
}
